import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import { getAllReferrals } from "../../../service/Referral/action";
import ReferralsPending from "./referralsPending";

const mapStateToProps = (state) => ({
    referralList:state.Referral.referralList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getAllReferrals
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ReferralsPending);
